import { Injectable } from '@tanbo/vue-di-plugin'
import { Http } from '@/services/http'

export interface MetricServerStatusData {
  /** 服务器状态,1=正常，2=异常 */
  status: number
  /** cup使用率 */
  cpu_usage: number
  /** 磁盘总量 */
  total_disk_mb: number
  /** 磁盘已使用总量 */
  used_disk_mb: number
  /** 物理内存总量 */
  total_memory_mb: number
  /** 物理内存已使用量总量 */
  used_memory_mb: number
  /** 交换分区总量 */
  total_swap_mb: number
  /** 交换分区已使用量总量 */
  used_swap_mb: number
}

export interface MetricServerStatusRes {
  data?: MetricServerStatusData
}

@Injectable()
export class OverallRunService {
  constructor (private http: Http) {
  }

  getMetricServerStatus () {
    return this.http.post<MetricServerStatusRes>('/metric/server_status', {})
  }
}
